import { render, staticRenderFns } from "./StartPlace.vue?vue&type=template&id=4b647e98&scoped=true&"
import script from "./StartPlace.vue?vue&type=script&lang=js&"
export * from "./StartPlace.vue?vue&type=script&lang=js&"
import style0 from "./StartPlace.vue?vue&type=style&index=0&id=4b647e98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b647e98",
  null
  
)

export default component.exports